import React, { useMemo, useState } from 'react'
import ShowMore from 'components/ShowMore'
import { Tooltip } from '@primer-io/goat'
import { CurrencyData, CurrencyNarrowSymbol } from './currencyData'
import { BodyLarge } from 'ds/TextGoat'

const MAX_ITEMS = 10

const CurrencyList = ({ currencyCodes }) => {
	const [isShowingMore, setIsShowingMore] = useState(false)

	const sortedCurrencyCodes = useMemo(
		() => currencyCodes.slice(0, isShowingMore ? undefined : MAX_ITEMS).sort(),
		[currencyCodes, isShowingMore],
	)

	return (
		<div>
			<div>
				{sortedCurrencyCodes.map((currencyCode, index) => (
					<React.Fragment key={currencyCode}>
						<Tooltip>
							<Tooltip.Trigger style={{ display: 'inline-flex' }}>
								<BodyLarge>{currencyCode}</BodyLarge>
							</Tooltip.Trigger>
							<Tooltip.Content side='top' mode='light'>
								{CurrencyNarrowSymbol[currencyCode]} {CurrencyData[currencyCode]?.displayName}
							</Tooltip.Content>
						</Tooltip>
						{index !== sortedCurrencyCodes.length - 1 && <span>, </span>}
					</React.Fragment>
				))}
			</div>

			{currencyCodes.length > MAX_ITEMS && !isShowingMore && (
				<ShowMore onClick={() => setIsShowingMore(!isShowingMore)} />
			)}
		</div>
	)
}

export default CurrencyList
